import { useCallback, useEffect, useRef } from 'react';

const MENU_CLOSE_DELAY_MS = 100;

export default function useHoverMenu(openMenu: () => void, closeMenu: () => void) {
  const closeTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const cancelScheduledClose = useCallback(() => {
    if (closeTimerRef.current !== null) {
      clearTimeout(closeTimerRef.current);
      closeTimerRef.current = null;
    }
  }, []);

  const openOnHover = useCallback(() => {
    cancelScheduledClose();
    openMenu();
  }, [cancelScheduledClose, openMenu]);

  const closeAfterPointerLeaves = useCallback(() => {
    cancelScheduledClose();
    closeTimerRef.current = setTimeout(closeMenu, MENU_CLOSE_DELAY_MS);
  }, [cancelScheduledClose, closeMenu]);

  useEffect(() => cancelScheduledClose, [cancelScheduledClose]);

  return {
    onMouseEnter: openOnHover,
    onMouseLeave: closeAfterPointerLeaves,
  };
}
